import React, { useContext } from "react";
import logodark from "../assets/image/logodark.png";
import { Link, NavLink } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext";
import translations from "../data/langData";
import { ApiLinkContext } from "../context/ApiLinkContext";
import slugify from "react-slugify";
const Footer = () => {
  const { language } = useContext(LanguageContext);
  const { coaching } = useContext(ApiLinkContext);
  const t = translations[language];
  const date = new Date();
  const currentYear = date.getFullYear();

  return (
    <>
    <NavLink to="/contact">
    <div className="floating-container">
          <div className="floating-button">
            <i className="fa-solid fa-info"></i>
          </div>
          {/* <div className="element-container">
            <span className="float-element">
              <i className="fa-brands fa-whatsapp fs-5"></i>
            </span>
            <span className="float-element">
            <i className="fa-regular fa-comment-dots fs-5"></i>
            </span>
          </div> */}
        </div>
    </NavLink>
      <div className="footer-section section" style={{ background: "#171621" }}>
        <div className="container">
          {/* Footer Top Widgets Start */}
          <div className="row">
            {/* Footer Widget Start */}
            <div className="col-xl-3 col-md-5 col-12 max-mb-50">
              <div className="footer-widget light-color">
                <h4 className="footer-widget-title">{t.address}</h4>
                <div className="footer-widget-content">
                  <div className="content">
                    <p>Bakı / Azərbaycan</p>
                    <p>
                      <a href="mailto:turanozbahceci@turanozbahceci.com">
                        turanozbahceci@turanozbahceci.com
                      </a>
                    </p>
                  </div>
                  <div className="footer-social-inline">
                    <a
                      href="https://www.facebook.com/ozbahceci.az"
                      target="_blank"
                    >
                      <i className="fab fa-facebook-square" />
                    </a>
                    <a
                     href="https://whatsapp.com/channel/0029VaLJawGLikg9FyNGPt0M"
                      target="_blank"
                    >
                      <i className="fa-brands fa-whatsapp"></i>
                    </a>
                    <a
                      href="https://www.tiktok.com/@turanozbahceci?lang=tr-TR"
                      target="_blank"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.instagram.com/ozbahcheci/"
                      target="_blank"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.linkedin.com/in/turan-ozbahceci-793213139/"
                      target="_blank"
                    >
                      <i className="fab fa-linkedin" />
                    </a>
                    <a
                      href="https://www.youtube.com/channel/UCmSeMwPTRlAaY4NN2Bdl-6w"
                      target="_blank"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://t.me/turanozbahceci"
                      target="_blank"
                    >
                      <i className="fab fa-twitter" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            {/* Footer Widget End */}
            {/* Footer Widget Start */}
            <div className="col-xl-3 col-md-4 col-sm-7 col-6 max-mb-50">
              <div className="footer-widget light-color">
                <h4 className="footer-widget-title">{t.isimkanlari}</h4>
                <div className="footer-widget-content">
                  <ul className="column-1">
                    <li>
                      <a href="#">{t.karyeramerkezi1}</a>
                    </li>
                    <li>
                      <a href="#">{t.karyeramerkezi3}</a>
                    </li>
                    <li>
                      <a href="#">{t.insanresurs1}</a>
                    </li>
                    <li>
                      <a href="#">{t.insanresurs2}</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-md-4 col-sm-7 col-6 max-mb-50">
              <div className="footer-widget light-color">
                <h4 className="footer-widget-title"> {t.coaching}</h4>
                <div className="footer-widget-content">
                  <ul className="column-1">
                    {coaching.map((item) => {
                      return (
                        <li>
                          <NavLink
                            to={`coachings/${slugify(
                              `${item.id}-${item.name}`
                            )}`}
                          >
                            {" "}
                            {language == "az"
                                      ? item.name
                                      : language == "en"
                                      ? item.name_en
                                      : language == "ru"
                                      ? item.name_ru
                                      : language == "tr"
                                      ? item.name_tr
                                      : language == "de"
                                      ? item.name_de
                                      : language == "pl"
                                      ? item.name_pl
                                      : ""}
                          </NavLink>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-md-4 col-sm-7 col-6 max-mb-50">
              <div className="footer-widget light-color">
                <h4 className="footer-widget-title">{t.contactwe}</h4>
                <div className="footer-widget-content">
                  <ul className="column-1">
                    <li>
                      <NavLink to="/contact">{t.contactustitle}</NavLink>
                    </li>
                    <li>
                      <Link to="/privacypolicy">{t.privacy}</Link>
                    </li>
                    <li>
                      <NavLink
                        to="/termsofuse"
                        style={{ textTransform: "capitalize" }}
                      >
                        {t.terms}
                      </NavLink>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div className="row max-mt-20">
            <div className="col">
              <p className="copyright">
                © {currentYear} Turan Özbahçeci. {t.copyright}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
